import { render, staticRenderFns } from "./UserAdministrationPage.vue?vue&type=template&id=8f8918be&scoped=true&"
import script from "./UserAdministrationPage.vue?vue&type=script&lang=ts&"
export * from "./UserAdministrationPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdministrationPage.vue?vue&type=style&index=0&id=8f8918be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8918be",
  null
  
)

export default component.exports